import { Query, VisitorGroup } from 'graphql/generated/graphqlTypes';
import { removeFields } from 'mocks/graphqlMocks/removeFields';
import { generateMockVisitorGroup } from 'mocks/graphqlMocks/visitorGroup';

export function getVisitorGroupsForTenantWithIsAdminGroupDataForQuery(
  getVisitorGroupsForTenant: Array<VisitorGroup>
): Pick<Query, 'getVisitorGroupsForTenant'> {
  return {
    getVisitorGroupsForTenant
  };
}

const fieldsToRemoveFromVisitorGroups: (keyof VisitorGroup)[] = [
  'accessGrants',
  'allowedAccessGrants',
  'defaultAccessGrants',
  'scheduledAccessGrants',
  'maxNumberOfMembers',
  'members',
  'memberIds',
  'tenantId',
  'type'
];

export const mockedGetVisitorGroupsForTenantWithIsAdminGroupDataForQuery =
  getVisitorGroupsForTenantWithIsAdminGroupDataForQuery([
    removeFields(
      generateMockVisitorGroup({
        id: 'mockedVisitorGroupId1',
        name: 'noAdminGroup',
        isAdminGroup: false,
        externalRef: 'mockedVisitorGroupExternalRef1'
      }),
      fieldsToRemoveFromVisitorGroups
    ),
    removeFields(
      generateMockVisitorGroup({
        id: 'mockedVisitorGroupId2',
        name: 'adminGroup',
        isAdminGroup: true,
        externalRef: 'mockedVisitorGroupExternalRef2'
      }),
      fieldsToRemoveFromVisitorGroups
    )
  ]);

export const mockedGetVisitorGroupsForTenantWithIsAdminGroupDataAdmin =
  getVisitorGroupsForTenantWithIsAdminGroupDataForQuery([
    generateMockVisitorGroup({
      id: 'mockedIdAdmins',
      name: 'admins',
      externalRef: 'mockedExternalRefAdmins',
      isAdminGroup: true
    }),
    generateMockVisitorGroup({
      id: 'mockedIdEmployees',
      name: 'employees',
      externalRef: 'mockedExternalRefEmployees',
      isAdminGroup: true
    }),
    generateMockVisitorGroup({
      id: 'mockedIdVisitor_group_1',
      name: 'visitor_group_1',
      externalRef: 'mockedExternalRefVisitor_group_1',
      isAdminGroup: true
    }),
    generateMockVisitorGroup({
      id: 'mockedIdVisitor_group_2',
      name: 'visitor_group_2',
      externalRef: 'mockedExternalRefVisitor_group_2',
      isAdminGroup: true
    }),
    generateMockVisitorGroup({
      id: 'mockedIdVisitor_group_3',
      name: 'visitor_group_3',
      externalRef: 'mockedExternalRefVisitor_group_3',
      isAdminGroup: true
    })
  ]);
